
/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect, useImperativeHandle } from 'react';
import { Row, Col, Image, Space, Modal } from "antd";
import { NavLink } from "react-router-dom";
import AddIcon from "../../../../../../assets/images/icon_actions/Add Icon.svg";
import { PrimaryDrawer } from "../../../../../Shared/components/Drawer/PrimaryDrawer";
import CustomInfiniteScroll from "../../../../../Shared/components/CustomInfiniteScroll";
import { transferLineHead } from '../../../../../../config/constant';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { TableCell, TableRow, Button, TextField, Checkbox } from "@mui/material";
import ExportIcon from "../../../../../../assets/images/icon_actions/Export.svg";
import { toast } from 'react-toastify';
import ViewIcon from "../../../../../../assets/images/icon_actions/View.svg";
import EditIcon from "../../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../../assets/images/icon_actions/Delete Icon.svg";
import { getBusinessId } from "../../../../../../helpers/utilities";
import { emptyValidation, customNumberValidation } from "../../../../../../helpers/validation";
import { getRequest } from '../../../../../../helpers/axiosClient';
import { exportCommonFile } from '../../../../../../helpers/utilities';
import SearchIcon from "../../../../../../assets/images/icon_actions/Search Icon.svg";
import ClearIcon from "../../../../../../assets/images/icon_actions/Clear Icon.svg";
import { RunQuery } from "./RunQuery";
import { LineForm } from "./LineForm";


export const LinesList = React.forwardRef((props, ref) => {
    const { classes, clsx, form, lines, getColumnWidth, unitMesurementdetails, changeHandlerLine, handleBulkDelete, batch,
        currencyFormat, dispatch, productActions, idNamingConversion, productGroupApi, setBatch, customObject, receivedView, status,
        lineSubmit, deleteLine, headerView, useEventListener, locationDetails, productApi, search, setSearch, createProduct, parameterDetails
    } = props;
    const priceRef = useRef(null);
    const addLineRef = useRef(null);
    const [filterForm, setFilterForm] = useState({
        type: 'on_hand',
        locationId: form?.locationId || ''
    });
    const [lineForm, setLineForm] = useState({});
    const [lineError, setLineError] = useState({});
    const [visible, setVisible] = useState(false);
    const [filterVisible, setFilterVisible] = useState(false);
    const [title, setTitle] = useState('Add');

    const [lineId, setLineId] = useState('');
    const [view, setView] = useState(false);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [lineName, setLineName] = useState('');
    const [units, setUnits] = useState([]);
    const [selected, setSelected] = useState([]);

    const [iconAnimation, setIconAnimation] = useState(false);

    const handleOpen = () => {
        setTitle('Add');
        setVisible(!visible);
        setView(false);
        setLineForm({
            lineNumber: parseInt(lines?.length + 1),
        });
        productApi();
        setLineId('');
        setLineError({});
        setBatch([]);
    }

    useImperativeHandle(ref, () => ({
        getVisible() {
            return visible
        },
        handleLineSubmit(e) {
            handleLineSubmit(e)
        },
        handleUnits(d) {
            handleUnits(d)
        },
        handleBulkUnits(ids) {
            handleBulkUnits(ids)
        },
        handleSelected(ids) {
            setSelected(ids);
        },
        handleFilterForm() {
            setFilterForm({
                type: 'on_hand',
                locationId: form?.locationId || ''
            })
        }
    }));


    useEffect(() => {
        setLineForm({
            ...lineForm, quantity: 0,
        });
    }, []);


    const onEdit = (data, i, view = false) => {
        setLineId(i);
        setTitle(view ? 'View' : 'Edit');
        setView(view);
        setVisible(!visible);
        data.pricePerUnit = data?.pricePerUnit || 0;
        setLineForm(data);
        productApi('', data?.productId || '');
        handleUnits(data.product);
        const updatedBatches = data?.batchDetails?.map(el => ({
            ...el,
            currentStock: el?.availableStock,
        })) || [];
        setBatch(updatedBatches);
    }

    const onDelete = (data, i) => {
        setDeleteVisible(true);
        setLineId(i);
        setLineName(data?.product?.productName || '');
    }



    const handleProductChange = async (d) => {
        if (d?.id) {
            let data = {
                productId: d?.id,
                product: d
            }

            data['unitId'] = d?.salesUnitId || '';
            data['unit'] = d.salesUnit || '';
            data['universalProductId'] = d.universalProductId;
            data['batchOverride'] = d?.batchActivation || false;

            if (locationDetails && locationDetails?.length > 0) {
                let a = locationDetails?.filter(el => el.default);
                if (a?.length) {
                    data.locationId = a[0]?.id;
                    data.location = a[0];
                } else {
                    data.locationId = locationDetails[0]?.id;
                    data.location = locationDetails[0];
                }
            }
            data.locationId = form?.locationId || data?.locationId || '';
            data.location = form?.location || data?.location || '';
            data.toLocationId = form?.toLocationId || '';
            data.toLocation = form?.toLocation || '';
            await getProductBatch(d?.id, data.locationId);
            getAvailableQty({ ...lineForm, ...data });
            handleUnits(d);
        }
    }

    const getProductBatch = async (id, locationId) => {
        try {
            let f = { where: { ["and"]: [{ productId: id }, { locationId: locationId }, { availableStock: { gt: 0 } }] } };

            const response = await getRequest(`${process.env.REACT_APP_API_URL}/product-batch-numbers/byProduct/${id}?filter=${encodeURIComponent(JSON.stringify(f))}`);
            const data = response.data;
            let val = [];
            if (data && data.length) {
                val = data.map(item => ({
                    batchNumber: item?.batchNumber || '',
                    batchId: item?.id || '',
                    manufacturingDate: item?.manufacturingDate || null,
                    expiryDate: item?.expiryDate || null,
                    useByDate: item?.useByDate || null,
                    bestBeforeDate: item?.bestBeforeDate || null,
                    perUnitPrice: item?.perUnitPrice || '',
                    mrp: item?.mrp || '',
                    availableStock: item?.availableStock || '',
                    toQuantity: item?.toQuantity || '',
                    productId: item?.productId || '',
                    universalProductId: item?.universalProductId || '',
                    locationId: item?.locationId || '',
                    toLocationId: lineForm?.toLocationId || '',
                }));
            } else {
                val = [];
            }

            setBatch(val);
            return val;
        } catch (error) {
            setBatch([]);
            return [];
        }
    }

    const handleBulkUnits = (products) => {
        // Initialize a map to collect unitIds per product
        const unitMap = {};
        products.forEach(p => {
            unitMap[p.id] = [p.salesUnitId, p.skuUnitId].filter(Boolean);
        });

        setUnits(prev => {
            const updated = { ...prev };
            Object.keys(unitMap).forEach(pid => {
                updated[pid] = unitMesurementdetails.filter(el => unitMap[pid].includes(el.id));
            });
            return updated;
        });
    };

    const getAvailableQty = async (lineForm) => {
        try {
            const response = await getRequest(`${process.env.REACT_APP_API_URL}/stock-on-hands/byProduct/${lineForm?.productId}/${lineForm?.unitId}/${lineForm?.locationId}`);
            const data = response.data;
            let availableQty = 0; let costPrice = 0;
            if (data?.length && data[0]?.units?.length) {
                let qty = data[0]?.units.find(obj => obj.hasOwnProperty(lineForm?.unitId))?.[lineForm?.unitId];

                availableQty = parseFloat(parseFloat(qty).toFixed(2));
            }


            if (data?.length && data[0]?.cPrice?.length) {
                let qty = data[0]?.cPrice.find(obj => obj.hasOwnProperty(lineForm?.unitId))?.[lineForm?.unitId];
                costPrice = parseFloat(parseFloat(qty).toFixed(2));
            }

            setLineForm({
                ...lineForm,
                pricePerUnit: costPrice,
                quantity: availableQty,
                toQuantity: '',
                amount: availableQty * costPrice,
            });
        } catch (error) {
            console.log(error);
        }
    }

    const handleUnits = (data) => {
        let filter = {
            where: {
                and: [{ productId: data?.id }, { or: [{ unitId: data?.salesUnitId }, { toUnitId: data?.salesUnitId },] }]
            }
        }; let uFilter = {
            where: {
                or: [{ unitId: data?.salesUnitId }, { toUnitId: data?.salesUnitId }]
            }
        };
        let a = [data?.salesUnitId, data?.skuUnitId];

        getRequest(`${process.env.REACT_APP_API_URL}/product-unit-conversions/?filter=${encodeURIComponent(JSON.stringify(filter))}`)
            .then(response => {
                let data = response.data;
                if (data && data.length > 0) {
                    data.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId);
                    });
                }
                return getRequest(`${process.env.REACT_APP_API_URL}/unit-conversions/?filter=${encodeURIComponent(JSON.stringify(uFilter))}`);
            }).then(uResponse => {
                let uData = uResponse.data;
                if (uData && uData.length > 0) {
                    uData.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId)
                    });
                }
                const filtered = unitMesurementdetails.filter(el => a.includes(el.id));
                setUnits(prev => {
                    return {
                        ...prev,
                        [data?.id]: filtered  // Append `filtered` array
                    };
                });
            })
            .catch(error => {
                console.error("Error fetching data", error);
            });
    }

    useEffect(() => {
        if (lineForm.toQuantity) {
            let amt = lineForm.toQuantity * lineForm.pricePerUnit;
            setLineForm({
                ...lineForm, amount: amt
            });
        }
    }, [lineForm.toQuantity]);


    const changeHandler = async (e, name = '') => {
        if (name !== '') {
            if (name === 'unitId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'unit': e
                });
            } else if (name === 'locationId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'location': e
                });
                await getProductBatch(lineForm?.productId, e.id);
                getAvailableQty({
                    ...lineForm,
                    [name]: e.id,
                    'location': e
                });
            } else if (name === 'toLocationId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'toLocation': e
                });
            } else {
                setLineForm({
                    ...lineForm,
                    [name]: e
                });
            }
        } else {
            setLineForm({
                ...lineForm,
                [e.target.name]: e.target.value
            });
        }
    }

    const handleQuantityChange = (value) => {
        if (lineForm?.productId && value) {
            if (priceRef.current !== null) {
                clearTimeout(priceRef.current);
            }
            priceRef.current = setTimeout(() => {
                priceRef.current = null;
                dispatch({
                    type: productActions.PRODUCT_PRICE_START,
                    url: `/saledprice/${form?.customerId}/${lineForm?.productId}/${value}`
                });
            }, 500);
        }
    }

    const handleAddMore = (e) => {
        handleLineSubmit(e, true);
    }

    const handleLineSubmit = (e, more = false) => {
        e.preventDefault();
        let emptyProduct = emptyValidation('Product', lineForm?.productId, 'dropDown');
        let emptyUnit = emptyValidation('Unit', lineForm?.unitId, 'dropDown');
        let emptyPrice = customNumberValidation('Price', lineForm?.pricePerUnit);
        let emptyAmount = emptyValidation('Line Amount', lineForm?.amount);
        let emptyQuantity = emptyValidation('To Quantity', lineForm?.toQuantity);
        let emptyLocation = emptyValidation('Location', lineForm?.locationId, 'dropDown');
        let emptyToLocation = emptyValidation('To Location', lineForm?.toLocationId, 'dropDown');

        let batchQuantityError = { isValid: true, errors: '' };

        if (lineForm?.batchOverride && batch.length === 0) {
            batchQuantityError = { isValid: false, errors: "Please enter Batch Details" }
        }

        if (batch.length > 0 && lineForm?.batchOverride) {
            let batchQuantity = batch?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.toQuantity || 0)), 0);

            //let batchQuantity = batch?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.purchaseQuantity || 0)), 0);
            if (status === 'CREATED' && batchQuantity !== parseFloat(lineForm?.toQuantity)) {
                batchQuantityError = { isValid: false, errors: 'Total Batch quantity should equal Line Quantity' }
            }
            let batchreceiQuantity = batch?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.receivedQuantity || 0)), 0);
            if (status === 'SHIPPED' && batchreceiQuantity !== parseFloat(lineForm?.receivedQuantity)) {
                batchQuantityError = { isValid: false, errors: 'Total Batch quantity should equal Line Quantity' }
            }
        }
        if (lineId === '' && lineForm?.productId && lines.some(line => line.productId === lineForm?.productId)) {
            emptyProduct = { isValid: false, errors: `Product already exists in Line "${lineId}". Go to Line "${lineId}" to update the quantity.` };
        }

        setLineError({});
        if (emptyProduct.isValid && emptyUnit.isValid && emptyLocation.isValid && emptyToLocation.isValid &&
            emptyPrice.isValid && emptyQuantity.isValid && emptyAmount.isValid && batchQuantityError.isValid) {
            lineForm.quantity = parseFloat(lineForm.quantity);
            if (batch?.length > 0) {
                let aL = [];
                batch?.map((element, i) => {
                    element.perUnitPrice = lineForm?.pricePerUnit || 0;
                    element.availableStock = parseFloat(element?.availableStock || 0);
                    element.toQuantity = parseFloat(element?.toQuantity || 0);
                    element.mrp = element?.mrp || 0;
                    element.unitId = lineForm?.unitId;
                    element.businessId = getBusinessId();
                    if (lineForm?.productId) element.productId = lineForm?.productId
                    return aL.push(element)
                });
                lineForm["batchDetails"] = lineForm?.batchOverride ? aL : [];
            } else {
                lineForm["batchDetails"] = [];
            }
            lineSubmit(lineForm, lineId);
            handleOpen();
            if (more) {
                setTimeout(function () {
                    addLineRef.current.click();
                }, 500)
            }
            setLineId('');
        } else {
            setLineError({
                productId: emptyProduct?.errors || false,
                unitId: emptyUnit?.errors || false,
                locationId: emptyLocation?.errors || false,
                toLocationId: emptyToLocation?.errors || false,
                pricePerUnit: emptyPrice?.errors || false,
                toQuantity: emptyQuantity?.errors || false,
                batchQuantity: batchQuantityError?.errors || false
            })
        }
    }

    const handleKeyDown = (e) => {
        if (!headerView && e.altKey && e.keyCode === 76) {
            e.preventDefault();
            if (form?.customerId) {
                handleOpen();
            } else {
                toast.dismiss();
                toast.error('Please select customer then add lines.');
            }
        }
    };

    const handleBulkLines = () => {
        setFilterVisible(!filterVisible);
        setFilterForm({
            type: 'on_hand',
            locationId: form?.locationId || ''
        });
        productApi();
        productGroupApi();
    }

    const changeFilterHandler = (e, name) => {
        setFilterForm({
            ...filterForm,
            [name]: e
        })
    }

    const loadImportExportData = (data) => {
        exportCommonFile(data, lines);
    }

    useEventListener("keydown", handleKeyDown);

    const handleClick = (e, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const isSelected = (name) => selected.indexOf(name) !== -1;


    return (
        <>
            <Row>
                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                    <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                        <TextField autoComplete='one-time-code'
                            placeholder='Search Product Name & ID, Unit, Location'
                            type='search'
                            value={search}
                            id={idNamingConversion('Search', 'stockCount', 'TextField')}
                            onChange={(e) => setSearch(e.target.value)}
                            className={classes.comInput}
                            variant={'standard'}
                            fullWidth
                            onFocus={() => setIconAnimation(true)}
                            onBlur={() => setIconAnimation(false)}
                        />
                        <Image
                            src={SearchIcon}
                            preview={false}
                        />
                        {
                            search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                <Image
                                    src={ClearIcon}
                                    preview={false}
                                />
                            </NavLink>
                        }
                    </div>
                </Col>
                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={classes.textAlignRight}>
                    <Space direction="horizontal" align="center" size={[10, 10]}>
                        {
                            selected?.length > 0 ? <NavLink to={'#'} onClick={() => { handleBulkDelete(selected) }} className={clsx(classes.customLink, classes.disInline)}>
                                <Image
                                    src={ExportIcon}
                                    preview={false}
                                    className={clsx(classes.antImage)}
                                /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Bulk Delete</span>
                            </NavLink> : null
                        }
                        {
                            lines?.length > 0 ? <NavLink to={'#'} onClick={() => { loadImportExportData('Stock Count Lines') }} className={clsx(classes.customLink, classes.disInline)}>
                                <Image
                                    src={ExportIcon}
                                    preview={false}
                                    className={clsx(classes.antImage)}
                                /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                            </NavLink> : null
                        }
                        {
                            !headerView && locationDetails && locationDetails?.length > 0 && <>
                                {
                                    form?.toLocationId && <NavLink to={'#'} onClick={() => handleBulkLines()} className={clsx(classes.customLink, classes.disInline)}>
                                        <Image
                                            src={AddIcon}
                                            preview={false}
                                            className={clsx(classes.antImage)}
                                        /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Create Stock Transfer Lines</span>
                                    </NavLink>
                                }
                                {
                                    !headerView && form?.toLocationId &&
                                    <NavLink to={'#'} ref={addLineRef} onClick={() => handleOpen()} className={clsx(classes.customLink, classes.disInline)}>
                                        <Image
                                            src={AddIcon}
                                            preview={false}
                                            className={clsx(classes.antImage)}
                                        /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Lines</span>
                                    </NavLink>
                                }
                            </>
                        }
                    </Space>
                </Col>
            </Row>
            <div className={clsx(classes.tableRoot)}>
                <CustomInfiniteScroll
                    loadMore={true}
                    loadMoreContent={false}
                    heads={headerView ? transferLineHead.filter(item => item.key !== 'checkbox') : transferLineHead}
                    width={true}
                    autoWidth={true}
                    selected={selected}
                    details={lines}
                    onSelected={(value) => setSelected(value)}
                    keyValue={'lineNumber'}
                    component={
                        <>
                            {
                                lines?.length > 0 ? lines.map((data, i) => (
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                        {
                                            headerView ? '' : <TableCell className={clsx('checkbox', classes.tablealign)} onClick={(e) => handleClick(e, data.lineNumber)} padding="checkbox">
                                                <Checkbox color="primary" checked={isSelected(data.lineNumber)} />
                                            </TableCell>
                                        }
                                        <TableCell style={{ width: 10 }}>{i + 1}</TableCell>
                                        <TableCell style={{ width: getColumnWidth(transferLineHead, 1) }}><NavLink style={{ width: getColumnWidth(transferLineHead, 1) }} to={"#"} className={clsx(classes.bold, classes.color)} onClick={() => onEdit(data, i, true)}><span className={classes.descEllipsis}>{data?.product?.productName || ''}</span></NavLink></TableCell>
                                        <TableCell style={{ width: getColumnWidth(transferLineHead, 2) }}><span style={{ width: getColumnWidth(transferLineHead, 2) }}>{data?.product?.productId || '---'}</span></TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.stockCountLineUnit)}>
                                            {data?.unit?.name || '---'}
                                        </TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.stockCountLineUnit)}>
                                            {data?.location?.name || '---'}
                                        </TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.stockCountLineUnit)}>
                                            {data?.quantity || 0}
                                        </TableCell>
                                        <TableCell className={clsx(classes.storeSalesLineCell)}>
                                            {
                                                headerView ? data?.toQuantity :
                                                    <TextField autoComplete='one-time-code'
                                                        fullWidth
                                                        style={{ width: "100%", maxWidth: "none" }}
                                                        className={clsx(classes.storeSalesLineQuantity)}
                                                        value={data?.toQuantity || ''}
                                                        type={'number'}
                                                        InputProps={{
                                                            classes: {
                                                                input: clsx(classes.textFieldColor, classes.storeSalesLineQuantityInput),
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            className: classes.textAreaLableColorCustom,
                                                        }}
                                                        inputProps={{
                                                            step: "any"
                                                        }}
                                                        id={idNamingConversion('To Quantity_' + i, 'stockTransferLine', 'TextField')}
                                                        onWheel={(e) => e.target.blur()}
                                                        onFocus={(e) => {
                                                            e.target.select();
                                                        }}
                                                        onChange={(e) => {
                                                            if (e.target.value < 0) {
                                                                changeHandlerLine(data, e.target.value = 0, 'toQuantity')
                                                            } else if (!parameterDetails?.transferNegativeStock && parseFloat(e.target.value) > parseFloat(data?.quantity || 0)) {
                                                                changeHandlerLine(data, e.target.value = (data?.quantity || ''), 'toQuantity')
                                                            } else {
                                                                changeHandlerLine(data, e.target.value, 'toQuantity')
                                                            }
                                                        }}
                                                    />
                                            }
                                        </TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.adjustStockLineUnit)}>
                                            {
                                                receivedView ? data?.receivedQuantity : <TextField autoComplete='one-time-code'
                                                    fullWidth
                                                    style={{ width: "100%", maxWidth: "none" }}
                                                    className={clsx(classes.storeSalesLineQuantity)}
                                                    value={data?.receivedQuantity || ''}
                                                    type={'number'}
                                                    InputProps={{
                                                        classes: {
                                                            input: clsx(classes.textFieldColor, classes.storeSalesLineQuantityInput),
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.textAreaLableColorCustom,
                                                    }}
                                                    inputProps={{
                                                        step: "any",
                                                        max: (data?.balanceQuantity || 0)
                                                    }}
                                                    id={idNamingConversion('Received Quantity_' + i, 'stockTransferLine', 'TextField')}
                                                    onWheel={(e) => e.target.blur()}
                                                    onFocus={(e) => {
                                                        e.target.select();
                                                    }}
                                                    disabled={status === 'CREATED' ? true : false}
                                                    onChange={(e) => {
                                                        if (e.target.value < 0) {
                                                            changeHandlerLine(data, e.target.value = 0, 'receivedQuantity')
                                                        } else if (parseFloat(e.target.value) > parseFloat(data?.balanceQuantity || 0)) {
                                                            changeHandlerLine(data, e.target.value = (data?.balanceQuantity || ''), 'receivedQuantity')
                                                        } else {
                                                            changeHandlerLine(data, e.target.value, 'receivedQuantity')
                                                        }
                                                    }}
                                                />
                                            }
                                        </TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.adjustStockLineUnit)}>
                                            {parseFloat(data?.balanceQuantity || 0)}
                                        </TableCell>
                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignRight)}>
                                            {`₹ ${currencyFormat(data?.pricePerUnit || 0)}`}
                                        </TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.adjustStockLineUnit)}>
                                            {
                                                headerView ? data?.toLocation?.name :
                                                    <AutoCompleteComponent
                                                        customLabel={"Location"}
                                                        heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                        details={locationDetails}
                                                        parentValue={customObject(locationDetails, data?.toLocationId)}
                                                        position={"bottom"}
                                                        variant={'outlined'}
                                                        orginPosVet={30}
                                                        orginPosHor={-100}
                                                        id={idNamingConversion('To Location_' + i, 'stockTransferLine', 'DropDown')}
                                                        onChange={(d) => changeHandlerLine(data, d, 'toLocationId', 'toLocation')}
                                                    />
                                            }
                                        </TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.adjustStockLineUnit)}>
                                            <span className={clsx(classes.statusButton, { [classes.submittedButton]: data?.lineStatus === 'SHIPPED' }, { [classes.confirmedButton]: data?.lineStatus === 'RECEIVED' })}>{data?.lineStatus || 'CREATED'}</span>
                                        </TableCell>
                                        <TableCell className={classes.textAlignRight}>
                                            <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding)}>
                                                <NavLink to={"#"} onClick={() => onEdit(data, i, true)}>
                                                    <Image
                                                        src={ViewIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                                {
                                                    !headerView && <NavLink to={"#"} onClick={() => onEdit(data, i)}>
                                                        <Image
                                                            src={EditIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                }
                                                {
                                                    !headerView &&
                                                    <NavLink to={"#"} onClick={() => onDelete(data, i)}>
                                                        <Image
                                                            src={DeleteIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                }
                                            </Space>
                                        </TableCell>
                                    </TableRow>
                                )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell style={{ textAlign: "center" }} colSpan={10}>
                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by Adding Lines to your stock'}</p>
                                    </TableCell>
                                </TableRow>
                            }
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleOpen()}
                width={'850px'}
                title={title + ' Stock Transfer Lines'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <LineForm {...props}
                        handleLineSubmit={(e) => handleLineSubmit(e)}
                        lineForm={lineForm}
                        title={title}
                        view={view}
                        units={units}
                        headerView={headerView}
                        handleAddMore={(e) => handleAddMore(e)}
                        lineError={lineError}
                        handleEdit={(v) => setView(v)}
                        currencyFormat={(amount) => currencyFormat(amount)}
                        handleQuantityChange={(v) => handleQuantityChange(v)}
                        changeHandler={(e, name) => changeHandler(e, name)}
                        handleProductChange={(data) => handleProductChange(data)}
                    />
                }
            />
            <RunQuery
                {...props}
                visible={filterVisible}
                handleClose={() => setFilterVisible(!filterVisible)}
                createProduct={(filterForm) => createProduct(filterForm)}
                changeHandler={(e, name) => changeFilterHandler(e, name)}
                form={filterForm}
            />

            <Modal
                title={'Delete Confirmation'}
                open={deleteVisible}
                onOk={() => setDeleteVisible(false)}
                onCancel={() => setDeleteVisible(false)}
                className={clsx(classes.commonPopup, classes.deletePopup, classes.removeUnderline)}
                footer={[
                    <Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn)}
                        onClick={() => { setDeleteVisible(false); deleteLine(lineId) }}
                    >Yes</Button>,
                    <Button
                        key="no"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, classes.AddMoreBtn)}
                        onClick={() => setDeleteVisible(false)}>
                        No
                    </Button>,
                ]}>
                <p>Are you sure you want to <span className={classes.deleteRed}> Delete </span> {lineName}</p>
            </Modal>
        </>
    )
})